import { defineStore, acceptHMRUpdate } from 'pinia'

interface BusinessServiceTypeCardState {
  // Selection state shared between `ServiceTypesPane` and `InfoViewLayout`.
  // The type definition, stats, and occurrences stream are cached by TanStack
  // Query, not duplicated here.

  selectedBusinessServiceTypeId: string | null
  // Business service type id whose card is currently shown in
  // `InfoViewLayout`, or `null` when no row is selected.
}

/**
 * Cross-component selection state for the business service type info card.
 */
export const useBusinessServiceTypeCardStore = defineStore('businessServiceTypeCard', {
  state: (): BusinessServiceTypeCardState => ({
    selectedBusinessServiceTypeId: null,
  }),
  getters: {
    /** Convenience flag for `v-if` guards in components that mount the card. */
    hasSelection: (state): boolean => state.selectedBusinessServiceTypeId !== null,
  },
  actions: {
    /**
     * Open the card for the given business service type id. Idempotent so
     * re-clicking the selected row does not force the card through a fresh
     * mount cycle.
     */
    selectBusinessServiceType(id: string): void {
      if (this.selectedBusinessServiceTypeId === id) return
      this.selectedBusinessServiceTypeId = id
    },
    /** Close the card (hides it from `InfoViewLayout`). */
    clearSelection(): void {
      this.selectedBusinessServiceTypeId = null
    },
  },
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useBusinessServiceTypeCardStore, import.meta.hot))
}
